import * as V2Routes from './config'

export const useRouteMapper = () => {
  const routes = V2Routes

  return {
    ...routes.ROUTES_MAP,
    ALL_ROUTES: routes.ALL_ROUTES,
  }
}
